import { render, staticRenderFns } from "./completed.vue?vue&type=template&id=90ed2f3c&scoped=true&"
import script from "./completed.vue?vue&type=script&lang=ts&"
export * from "./completed.vue?vue&type=script&lang=ts&"
import style0 from "./completed.vue?vue&type=style&index=0&id=90ed2f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ed2f3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
